import { createStore } from "vuex";
import live from "./modules/live";

export default createStore({
	modules: {
		live,
	},
})